import rcStore from '../store/store';
import { logUsage } from 'owa-analytics';
import EmailAddressWrapper from 'owa-service/lib/contract/EmailAddressWrapper';
import PersonaType from 'owa-service/lib/contract/PersonaType';

export default function searchCache(
    searchQuery: string,
    numberOfResults: number,
    recipientsToExclude?: { EmailAddress: EmailAddressWrapper }[],
    mailboxTypesToExclude?: string[]
): PersonaType[] {
    let resultList: PersonaType[] = [];
    let i = 0;
    searchQuery = searchQuery.toLowerCase();
    while (
        resultList.length < numberOfResults &&
        (rcStore.recipientCache && i < rcStore.recipientCache.length)
    ) {
        let email = rcStore.recipientCache[i].EmailAddress;
        if (isEmailCacheHit(searchQuery, email)) {
            let skipRecipient = false;

            // Skip recipient if it's found in recipientsToExclude list
            if (recipientsToExclude && isDuplicated(email, recipientsToExclude)) {
                skipRecipient = true;
            }

            // Skip recipient if its mailbox type is in mailboxTypesToExclude
            if (mailboxTypesToExclude && mailboxTypesToExclude.indexOf(email.MailboxType) >= 0) {
                skipRecipient = true;
            }

            if (!skipRecipient) {
                resultList.push(rcStore.recipientCache[i]);
                logUsage('RecipientCacheHitIndex', [Math.ceil(i / 50)]);
            }
        }
        i++;
    }

    return resultList;
}

function isEmailCacheHit(searchQuery: string, email: EmailAddressWrapper): boolean {
    if (email.EmailAddress && email.EmailAddress.toLowerCase().indexOf(searchQuery) == 0) {
        return true;
    }

    const names = email.Name.toLowerCase().split(' ');
    for (let i = 0; i < names.length; i++) {
        if (names[i].indexOf(searchQuery) == 0) {
            return true;
        }
    }

    return false;
}

function isDuplicated(
    email: EmailAddressWrapper,
    recipientsToCheck: { EmailAddress: EmailAddressWrapper }[]
): boolean {
    for (var j = 0; j < recipientsToCheck.length; j++) {
        if (email.EmailAddress == recipientsToCheck[j].EmailAddress.EmailAddress) {
            return true;
        }
    }
    return false;
}
